/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  in: (key, values) => {
    let formattedValues 

    if (
      [
        'customer_name:in',
      ].includes(key)
    ) {
      formattedValues = values.map((value) => `"${value}"`)
    }

    if (
      [
        'customer_name:in',
      ].includes(key)
    ) {
      return `${key.replace(/:in/g, '')} in ${formattedValues.join(' ')}`
    }

    return `${key.replace(/:in/g, '')} in (${formattedValues.join(' ')})`
  },
}

const filterMappings = {
  'status.name': queryFiltersMappings.eq,
  'created_on:gte': queryFiltersMappings.gte,
  'created_on:lte': queryFiltersMappings.lte,
  'total_weight:gte': queryFiltersMappings.gte,
  'total_weight:lte': queryFiltersMappings.lte,
  'total_volume:gte': queryFiltersMappings.gte,
  'total_volume:lte': queryFiltersMappings.lte,
  'total_price:gte': queryFiltersMappings.gte,
  'total_price:lte': queryFiltersMappings.lte,
  'customer_name:in': queryFiltersMappings.in,
}

export default filterMappings
